/* Predictive search — live suggestions via Shopify Predictive Search API. */

class SearchModal extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-search-input]');
    this.results = this.querySelector('[data-search-results]');
    this.form = this.querySelector('[data-search-form]');
    this.includeCollections = this.dataset.includeCollections !== 'false';
    this.includePages = this.dataset.includePages !== 'false';
    this.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', () => this.close()));
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    this.input.addEventListener('input', () => this.debounced());
    this._t = null;
  }

  open() {
    this.hidden = false;
    requestAnimationFrame(() => this.setAttribute('data-open', ''));
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => this.input.focus(), 100);
  }
  close() {
    this.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { this.hidden = true; }, 280);
  }

  debounced() { clearTimeout(this._t); this._t = setTimeout(() => this.search(), 250); }

  async search() {
    const q = this.input.value.trim();
    if (q.length < 2) { this.results.innerHTML = ''; return; }
    try {
      const types = ['product', 'query'];
      if (this.includeCollections) types.push('collection');
      if (this.includePages) types.push('page');
      const params = new URLSearchParams({
        q,
        'resources[type]': types.join(','),
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search-results',
      });
      const res = await fetch(`${window.Shopify.routes.root}search/suggest?${params}`);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const inner = doc.querySelector('[data-predictive-inner]');
      this.results.innerHTML = inner ? inner.innerHTML : '';
    } catch (e) { console.error('Predictive search failed', e); }
  }
}
customElements.define('search-modal', SearchModal);

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-search-trigger]');
  if (!trigger) return;
  e.preventDefault();
  const modal = document.querySelector('search-modal');
  if (modal) modal.open();
});
